module.exports = __webpack_public_path__ + "static/media/MHSBC.899fdeac.png";